import { DialogActions, styled } from '@mui/material';

export const Content = styled('div')(({ theme }) => ({
  backgroundColor: '#f0f4f6',
  padding: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const ContentSpaced = styled(Content)(({ theme }) => ({
  padding: theme.spacing(4),
  marginBottom: theme.spacing(4),
}));

export const Actions = styled(DialogActions)(({ theme }) => ({
  margin: 0,
  padding: theme.spacing(1),
}));